<template>
  <v-dialog v-model="dialog" max-width="auto">
    <v-card>
      <v-card-title class="redColor d-flex text-white">
        <span class="headline">
          {{ $t("vehicle_entry.inventory_list.label") }}
        </span>
        <v-spacer />
        <v-btn variant="outlined" icon color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!---------------------------------------CAR DETAILS--------------------------------------->
        <v-row class="pa-4">
          <!--BRAND-->
          <v-col>
            <v-row class="d-flex flex-column">
              <span class="caption">{{
                $t("parts.advanced_search.brand")
              }}</span>
              <span v-if="car.brand" class="font-weight-bold">
                {{ car.brand.title }}
              </span>
            </v-row>
          </v-col>
          <!--MODEL-->
          <v-col>
            <v-row class="d-flex flex-column">
              <span class="caption">{{
                $t("parts.advanced_search.model")
              }}</span>
              <span v-if="car.model" class="font-weight-bold">
                {{ car.model.description }}
              </span>
            </v-row>
          </v-col>
          <!--VERSION-->
          <v-col>
            <v-row class="d-flex flex-column">
              <span class="caption">{{
                $t("parts.advanced_search.version")
              }}</span>
              <span v-if="car.version" class="font-weight-bold">
                {{ car.version.description }}
              </span>
            </v-row>
          </v-col>
          <!--ENGINE-->
          <v-col>
            <v-row class="d-flex flex-column">
              <span class="caption">{{
                $t("parts.advanced_search.engine")
              }}</span>
              <span v-if="car.version" class="font-weight-bold">
                {{ car.version.engineCode }}
              </span>
            </v-row>
          </v-col>
        </v-row>
        <!---------------------------------------PARTS LIST---------------------------------------->
        <template #progress>
          <v-progress-linear v-if="loading" color="red" indeterminate />
        </template>

        <v-list v-model:opened="openedGroup" class="ma-2">
          <v-list-group
            v-for="(group, index) in parts"
            :key="group._id"
            :value="group._id"
            no-action
            :class="index % 2 === 0 ? 'bg-grey-lighten-4' : ''"
          >
            <!-- Activator -->
            <template #activator="{ props }">
              <v-list-item v-bind="props">
                <v-list-item-title>
                  {{ group.category[$store.getters.language] || group._id }}
                </v-list-item-title>
              </v-list-item>
            </template>

            <!-- Content -->
            <div class="pa-2">
              <v-data-table
                :headers="headers"
                :items="group.items"
                :loading="loading"
                hide-default-footer
                density="compact"
                class="headers-style"
              >
                <template #progress>
                  <v-progress-linear color="red" indeterminate />
                </template>

                <!-- Custom rows -->
                <template #item="{ item }">
                  <tr>
                    <td>
                      <span
                        v-if="item.data?.description?.descriptionId?.title"
                        class="text-xs font-weight-bold"
                      >
                        {{
                          item.data.description.descriptionId.title[
                            $store.getters.language
                          ]
                        }}
                      </span>
                      <span
                        v-if="item.data?.description?.positionCode"
                        class="text-xs"
                      >
                        {{ getPosition(item.data.description.positionCode) }}
                      </span>
                    </td>

                    <td>{{ item.count }}</td>

                    <td>
                      <v-btn
                        icon
                        variant="text"
                        @click="search(item.data.description.descriptionCode)"
                      >
                        <v-icon>mdi-open-in-new</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-list-group>
        </v-list>

        <!-- ACTIONS -->
        <v-row justify-center>
          <!---->
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    headers: [
      { title: "Description", sortable: false, key: "description" },
      { title: "Actual quantity", sortable: false, key: "count" },
      { title: "Actions", sortable: false, key: "actions" },
    ],
    pagination: {
      rowsPerPage: 5,
      page: 1,
    },
    car: { brand: {}, model: {}, version: {} },
    parts: [],
    total: 0,
    notes: {},
    openedGroup: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getParts();
      },
      deep: true,
    },
    dialog(value) {
      if (!value) this.close();
    },
  },
  methods: {
    setHeaders() {
      this.headers[0].title = this.$t(
        "vehicle_entry.inventory_list.description",
      );
      this.headers[1].title = this.$t(
        "vehicle_entry.inventory_list.actual_quantity",
      );
      this.headers[2].title = this.$t("vehicle_entry.inventory_list.actions");
    },
    getParts() {
      this.loading = true;
      getRequest(
        "/part/vehicle-list-v2",
        `institution_id=${this.$store.getters.institutionId}&lang=${
          this.$store.getters.language
        }&brand=${this.car.brand.brandCode}&model=${
          this.car.model.modelCode
        }&version=${this.car.version.versionCode}&page=${
          this.pagination.page
        }&limit=${this.pagination.rowsPerPage}`,
      )
        .then((response) => {
          this.parts = response.parts.map((g) => ({ ...g, active: false }));
          this.total = response.count;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },

    open(data) {
      this.dialog = true;
      this.car = data.car;
      this.setHeaders();
      this.getParts();
    },
    close() {
      this.dialog = false;
      this.parts = [];
      this.total = 0;
      this.notes = {};
      this.$emit("close");
    },
    search(code) {
      this.$emit("search", { code });
      this.close();
    },
    getPosition(code) {
      switch (code) {
        case "S001":
          return this.$t("left");
        case "S002":
          return this.$t("right");
        default:
          return "";
      }
    },
  },
};
</script>
<style scoped>
:deep(.v-data-table thead tr) {
  background-color: black !important;
  color: white !important;
}
</style>
